import React, { useState, useEffect } from "react";
import { Layout, Menu, Card, Typography, Drawer } from "antd";
import { motion, AnimatePresence } from "framer-motion";

const { Sider, Content } = Layout;
const { Title } = Typography;

const HEADER_HEIGHT = 64;

const languages = [
  { key: "english", label: "English – Yoga" },
  { key: "mandarin", label: "Mandarin (Chinese) – 瑜伽 (Yújiā)" },
  { key: "hindi", label: "Hindi – योग )" },
  // { key: "spanish", label: "Spanish – Yoga" },
  // { key: "french", label: "French – Yoga" },
  // { key: "arabic", label: "Arabic – يوجا )" },
  // { key: "bengali", label: "Bengali – যোগ " },
  // { key: "portuguese", label: "Portuguese – Ioga" },
  // { key: "russian", label: "Russian – Йога " },
  // { key: "urdu", label: "Urdu – یوگا " },
  // { key: "indonesian", label: "Indonesian – Yoga" },
  // { key: "german", label: "German – Yoga" },
  // { key: "japanese", label: "Japanese – ヨガ " },
  // { key: "swahili", label: "Swahili – Yoga" },
  // { key: "marathi", label: "Marathi – योग " },
  // { key: "telugu", label: "Telugu – యోగా " },
  // { key: "turkish", label: "Turkish – Yoga" },
  // { key: "tamil", label: "Tamil – யோகா" },
  // { key: "vietnamese", label: "Vietnamese – Yoga" },
  // { key: "korean", label: "Korean – 요가 " },
  // { key: "italian", label: "Italian – Yoga" },
  // { key: "thai", label: "Thai – โยคะ (Yóká)" },
  // { key: "gujarati", label: "Gujarati – યોગ " },
  // { key: "persian", label: "Persian (Farsi) – یوگا " },
  // { key: "polish", label: "Polish – Joga" },
  // { key: "punjabi", label: "Punjabi – ਯੋਗ " },
  // { key: "malayalam", label: "Malayalam – യോഗ " },
  // { key: "kannada", label: "Kannada – ಯೋಗ " },
  // { key: "odia", label: "Odia – ଯୋଗ " },
  // { key: "malay", label: "Malay – Yoga" },
  // { key: "sundanese", label: "Sundanese – Yoga" },
  // { key: "hausa", label: "Hausa – Yoga" },
  // { key: "yoruba", label: "Yoruba – Yoga" },
  // { key: "igbo", label: "Igbo – Yoga" },
  // { key: "dutch", label: "Dutch – Yoga" },
  // { key: "romanian", label: "Romanian – Yoga" },
  // { key: "czech", label: "Czech – Jóga" },
  // { key: "greek", label: "Greek – Γιόγκα (Yogka)" },
  // { key: "hungarian", label: "Hungarian – Jóga" },
  // { key: "swedish", label: "Swedish – Yoga" },
  // { key: "assamese", label: "Assamese – যোগ " },
  // { key: "sinhala", label: "Sinhala – යෝග " },
  // { key: "nepali", label: "Nepali – योग " },
  // { key: "burmese", label: "Burmese – ယောဂ (Yawga)" },
  // { key: "amharic", label: "Amharic – ዮጋ " },
  // { key: "ukrainian", label: "Ukrainian – Йога " },
  // { key: "kazakh", label: "Kazakh – Йога " },
  // { key: "hebrew", label: "Hebrew – יוגה " },
  // { key: "tibetan", label: "Tibetan – ཡོ་ག (Yo-ga)" },
];

const siderItems = languages.map((lang) => ({
  key: lang.key,
  label: lang.label,
  children: [
    { key: `${lang.key}-category`, label: "Category" },
    { key: `${lang.key}-alphabet`, label: "Alphabet" },
  ],
}));

const YogaDictionaryMain = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [activeLanguage, setActiveLanguage] = useState("english");
  const [activeView, setActiveView] = useState("category");
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const fade = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      style={{
        minHeight: "100vh",
        background: "#f0f2f5",
        // marginTop: HEADER_HEIGHT,
        padding: isMobile ? "10px" : "30px 10px",
      }}
    >
      <Layout
        style={{
          maxWidth: "1340px",
          margin: "0 auto",
          background: "#fff",
          borderRadius: 16,
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <Sider
            width={260}
            style={{
              background: "#1f2937",
              position: "sticky",
              top: HEADER_HEIGHT,
              height: `calc(100vh - ${HEADER_HEIGHT}px)`,
              overflowY: "auto",
            }}
          >
            <div
              style={{
                padding: 16,
                textAlign: "center",
                color: "#fff",
                fontWeight: "bold",
                fontSize: 16,
              }}
            >
              Languages
            </div>

            <Menu
              theme="dark"
              mode="inline"
              items={siderItems}
              onClick={(e) => {
                const [lang, view] = e.key.split("-");
                setActiveLanguage(lang);
                setActiveView(view);
              }}
            />
          </Sider>
        )}
        {isMobile && (
          <Drawer
            title="Languages"
            placement="left"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            width={260}
            bodyStyle={{ padding: 0, background: "#1f2937" }}
          >
            <Menu
              theme="dark"
              mode="inline"
              items={siderItems}
              onClick={(e) => {
                const [lang, view] = e.key.split("-");
                setActiveLanguage(lang);
                setActiveView(view);
                setDrawerOpen(false);
              }}
            />
          </Drawer>
        )}

        <Content
          style={{
            padding: isMobile ? "12px" : "30px 40px",
            background: "#fff",
          }}
        >
          {isMobile && (
            <div
              style={{
                marginTop: 35,
                marginBottom: 16,
              }}
            >
              <button
                onClick={() => setDrawerOpen(true)}
                style={{
                  padding: "8px 14px",
                  borderRadius: 8,
                  border: "none",
                  background: "#1f2937",
                  color: "#fff",
                  fontSize: 16,
                }}
              >
                ☰ Languages
              </button>
            </div>
          )}

          <AnimatePresence mode="wait">
            {activeView === "category" && (
              <motion.div
                key="category"
                variants={fade}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <Card>
                  <Title level={4}>
                    {activeLanguage.toUpperCase()} – Category
                  </Title>

                  <p>
                    <b>Numbers:</b> ashta, chatur, dasha, eka, pancha
                  </p>
                  <p>
                    <b>Body Parts:</b> janu, mukha, hasta, pada, shirsha
                  </p>
                  <p>
                    <b>Animals:</b> gaja, ashva, matsya, mayura
                  </p>
                  <p>
                    <b>Nature:</b> chandra, surya, agni, vayu
                  </p>
                  <p>
                    <b>Yoga Terms:</b> asana, prana, dhyana, samadhi
                  </p>
                </Card>
              </motion.div>
            )}

            {/* ===== ALPHABET VIEW ===== */}
            {activeView === "alphabet" && (
              <motion.div
                key="alphabet"
                variants={fade}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <Card>
                  <Title level={4}>
                    {activeLanguage.toUpperCase()} – Alphabet (A)
                  </Title>

                  {[
                    ["adho mukha", "face downward"],
                    ["agni", "fire"],
                    ["ahimsa", "nonviolence"],
                    ["ajna", "to command"],
                    ["anahata", "unstruck"],
                    ["ananda", "happiness"],
                  ].map(([s, e]) => (
                    <div
                      key={s}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "6px 0",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>{s}</span>
                      <span style={{ color: "#555" }}>{e}</span>
                    </div>
                  ))}
                </Card>
              </motion.div>
            )}
          </AnimatePresence>
        </Content>
      </Layout>
    </motion.div>
  );
};

export default YogaDictionaryMain;
